<div class="user-management">
  <div class="container-fluid p-0">
    <div class="bg-white p-4 mt-2">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-wrap ms-2 me-2">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a (click)="router.navigate(['/users'])" class="cursor-pointer">Users</a>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                  <i class="fas fa-chevron-right me-2"></i> <span *ngIf="user?.userId > 0">{{user?.firstName}} {{user?.lastName}}</span> <span *ngIf="user?.userId == 0">New user</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div class="row pt-4">
        <div class="col-md-6">
          <h4 class="ms-2">
            <span *ngIf="user?.userId > 0">Modifiy User </span>
            <span *ngIf="user?.userId == 0">Add User </span> <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h4>
        </div>
      </div>

      <form name="userProfileForm" (ngSubmit)="submitForm(userProfileForm.value)" class="ps-2 pe-2" [formGroup]="userProfileForm" novalidate>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row mt-3">
              <label class="col-sm-3 col-form-label" for="userName">User Name</label>
              <div class="col-sm-9">
                <input id="userName"
                       type="text"
                       class="form-control"
                       formControlName="userName"
                       disabled="disabled" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row mt-3">
              <label class="col-sm-3 col-form-label" for="firstName">First Name</label>
              <div class="col-sm-9">
                <input id="firstName"
                       type="text"
                       class="form-control"
                       [ngClass]="{
                    'form-required-border':
                      submitted &&
                      userProfileForm.get('firstName').invalid &&
                      (userProfileForm.get('firstName').dirty ||
                        userProfileForm.get('firstName').touched)
                  }"
                       placeholder="First Name"
                       formControlName="firstName" />
                <small class="text-danger"
                       *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'firstName')
                  ">
                  First Name is required
                </small>
              </div>
            </div>
            <div class="form-group row mt-3">
              <label class="col-sm-3 col-form-label" for="email">Email Address</label>
              <div class="col-sm-9">
                <input id="email"
                       type="text"
                       class="form-control"
                       [ngClass]="{
                    'form-required-border':
                      submitted &&
                      userProfileForm.get('emailId').invalid &&
                      (userProfileForm.get('emailId').dirty ||
                        userProfileForm.get('emailId').touched)
                  }"
                       placeholder="Email Address"
                       formControlName="emailId" />
                <small class="text-danger" *ngIf="submitted && userProfileForm.hasError('required', 'emailId')">
                  Email address is required
                </small>
                <small class="text-danger" *ngIf="userProfileForm.get('emailId').hasError('email')">
                  Please enter a valid email address
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row mt-3">
              <label class="col-sm-3 col-form-label" for="lastName">Last Name</label>
              <div class="col-sm-9">
                <input id="lastName"
                       type="text"
                       class="form-control"
                       [ngClass]="{
                    'form-required-border':
                      submitted &&
                      userProfileForm.get('lastName').invalid &&
                      (userProfileForm.get('lastName').dirty ||
                        userProfileForm.get('lastName').touched)
                  }"
                       placeholder="Last Name"
                       formControlName="lastName" />
                <small class="text-danger" *ngIf="submitted && userProfileForm.hasError('required', 'lastName')">
                  Last Name is required
                </small>
              </div>
            </div>
            <div class="form-group row mt-3">
              <label class="col-sm-3 col-form-label" for="phoneNumber">Phone Number</label>
              <div class="col-sm-9">
                <div class="input-group d-flex w-100">
                  <span class="input-group-text bg-white" id="basic">
                    <i class="fas fa-phone"></i>
                  </span>
                  <div class="flex-grow-1">

                    <ngx-intl-tel-input [cssClass]="'form-control'"
                                        [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[
  SearchCountryField.Iso2,
  SearchCountryField.Name,
  SearchCountryField.DialCode
]"
                                        [separateDialCode]="true"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="selectedCountryISO"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [numberFormat]="PhoneNumberFormat.National"
                                        name="phoneNumber"
                                        formControlName="phoneNumberControl">
                    </ngx-intl-tel-input>
                    <small class="text-danger" *ngIf="submitted && userProfileForm.hasError('required', 'phoneNumberControl')">
                      Phone Number is required
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="user?.userId > 0">
          <div class="col-md-6">
            <div class="form-group row mt-3">
              <label class="form-label fw-bold" for="isAdmin">User Roles</label>
              <div class="col-sm-9">
                <mat-checkbox [formControl]="userProfileForm.get('isAdmin')" [disabled]="user.isPrimaryUser" class="form-check">
                  <mat-label class="me-2">  Admin</mat-label>
                </mat-checkbox>
              </div>
            </div>
          </div>

        </div>
        <div class="row mt-3"  *ngIf="notificationsFormArray" formArrayName="notifications">
          <div class="col-md-12">
            <label class="form-label fw-bold">Notification Settings</label>
            <div *ngFor="let notif of notificationsFormArray.controls; let i = index" [formGroupName]="i" class="form-check">
              <mat-checkbox class="me-1" formControlName="isEnable">
                <mat-label class="me-2">  {{ notif.get('name').value }}</mat-label>
              </mat-checkbox>


            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-end pt-3">
            <button type="button" class="btn btn-secondary me-2" (click)="router.navigate(['/users'])">
              <i class="fa fa-times"></i> Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-primary-color">
              <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader"></i>-->
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>
